import {http} from './config/config-receituario'
export default{
    listar:(token)=>{
        return http.get('categoria_conta',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, categoriaConta)=>{
        return http.post('categoria_conta', categoriaConta,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    atualizarCategoriaConta:(token, categoriaConta) =>{
        return http.put('categoria_conta/'+categoriaConta.id,categoriaConta,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    deleteCategoriaConta:(token, id)=>{
        return http.delete('categoria_conta/'+id,{
            headers:{
                'Authorization':token
            }
        })
    }
}